import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/constants";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pn_token", data.token);
      localStorage.setItem("pn_email", data.email);
      toast.success("Connexion réussie");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Identifiants invalides");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
        <Link to="/" className="flex items-center gap-3 justify-center mb-6">
          <img src={LOGO_URL} alt="Logo" className="h-14 w-14 object-contain" />
        </Link>
        <h1 className="font-heading font-extrabold text-2xl text-[#0B1F3A] text-center">Connexion admin</h1>
        <p className="text-center text-sm text-[#4B5563] mt-1 mb-6">Accès réservé à l'équipe Passerelle Numérique.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Courriel</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="pl-9" data-testid="admin-login-email" />
            </div>
          </div>
          <div>
            <Label>Mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="pl-9" data-testid="admin-login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#00B8D9] hover:bg-[#0096B3] font-semibold py-6" data-testid="admin-login-submit">
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <Link to="/" className="text-sm text-[#4B5563] hover:text-[#00B8D9]">← Retour au site</Link>
        </div>
      </div>
    </div>
  );
}
